import React from 'react';
import {getRule} from './services/rules';
import { parsePermissions } from '../../Shared/functions';
import ClipLoader from "react-spinners/ClipLoader";

class RuleDetail extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            rule:null,
            loading:false,
        }
    }

    componentDidMount = () => {
        this.setState({loading:true})
        getRule(this.props.data).then((result) => {
            this.setState({loading:false, rule:result.data.data[0]});
        }).catch(error => {
            this.setState({loading:false})
        })
    }

    renderPermissions = (permissions) => {
        let items;
        items = parsePermissions(permissions);
        if(items && items.length > 0){
            return(
                    <div>
                        <p style={{fontWeight:'bold'}}>{this.renderTitleByModule('analyst')}</p>
                        <div style={{display:'flex', flexDirection:'row'}}>
                            {this.renderPermissionsByModule(items[0].analyst)}
                        </div>
                        <p style={{fontWeight:'bold'}}>{this.renderTitleByModule('officials')}</p>
                        <div style={{display:'flex', flexDirection:'row'}}>
                            {this.renderPermissionsByModule(items[0].officials)}
                        </div>
                        <p style={{fontWeight:'bold'}}>{this.renderTitleByModule('penalities')}</p>
                        <div style={{display:'flex', flexDirection:'row'}}>
                            {this.renderPermissionsByModule(items[0].penalities)}
                        </div>
                        
                        <p style={{fontWeight:'bold'}}>{this.renderTitleByModule('rules')}</p>
                        <div style={{display:'flex', flexDirection:'row'}}>
                            {this.renderPermissionsByModule(items[0].rules)}
                        </div>
                        
                        <p style={{fontWeight:'bold'}}>{this.renderTitleByModule('vehicles')}</p>
                        <div style={{display:'flex', flexDirection:'row'}}>
                            {this.renderPermissionsByModule(items[0].vehicles)}
                        </div>  
                    </div>
                )
        }
        return '';
    }

    renderPermissionsByModule = (permissons) => {
        return permissons.map((item, index)=>{
            if(item.name === 'see') {
                return <p key={index} style={{marginRight:10}}>Ver : {item.value === true ? 'Si' : 'No'}</p>
            }
            if(item.name === 'create') {
                return <p key={index} style={{marginRight:10}}>Crear : {item.value === true ? 'Si' : 'No'}</p>
            }
            if(item.name === 'update') {
                return <p key={index} style={{marginRight:10}}>Actualizar : {item.value === true ? 'Si' : 'No'}</p>
            }
            if(item.name === 'delete') {
                return <p key={index} style={{marginRight:10}}>Eliminar : {item.value === true ? 'Si' : 'No'}</p>
            }
            return null;
        })
    }

    renderTitleByModule = (module) => {
        if(module === 'analyst') {
            return 'Modulo de Usuarios';
        }
        if(module === 'officials') {
            return 'Modulo de Funcionarios';
        }
        if(module === 'penalities') {
            return 'Modulo de Multas';
        }
        if(module === 'vehicles') {
            return 'Modulo de Vehiculos';
        }
        if(module === 'rules') {
            return 'Modulo de Grupos';
        }
    }

    render() {
        return(
            
            <div>
                {
                    this.state.loading ?                         
                        <center>
                            <ClipLoader
                                color={'gray'}
                                loading={true}
                                size={50}
                                aria-label="Loading Spinner"
                                data-testid="loader"/>
                        </center>
                    :
                    <div>
                         <div className="px-4 sm:px-0">
                            <h3 className="text-base/7 font-semibold text-gray-900">Detalles del grupo</h3>
                        </div>

                        <div className="mt-6 border-t border-gray-100">
                            <dl className="divide-y divide-gray-100">
                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                    <dt className="text-sm/6 font-medium text-gray-900">Nombre: </dt>
                                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{this.state.rule?.roleName}</dd>
                                </div>
                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                    <dt className="text-sm/6 font-medium text-gray-900">Permisos: </dt>
                                    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{this.renderPermissions(this.state.rule?.permissions)}</dd>
                                </div>
                            </dl>
                        </div>
                        <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                            <button
                                type="button"
                                data-autofocus
                                onClick={() => this.props.onBack()}
                                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                                >
                                Volver
                            </button>
                        </div>  
                    </div>
                }
                
            </div>
        )
    }

}

export default RuleDetail